import { useRef, useState } from "react";
import CameraIcon from "../../../public/images/icons/camera.svg";

export const VerificationUpload = ({ setFile }: any) => {
    const ref = useRef<any>();
    const [image, setImage] = useState<any>();

    const onInputChange = (event: any) => {
        if (event.target.files && event.target.files[0]) {
            const image = URL.createObjectURL(event.target.files[0])
            setImage(image);
            setFile(event.target.files[0]);
        }
        else {
            setImage(undefined);
            setFile(undefined);
        }
    }

    return (
        <div onClick={() => ref?.current.click()} className="max-w-[240px] w-full aspect-square rounded-2xl bg-secondary mx-auto relative overflow-hidden">
            <div className="h-full w-full cursor-pointer
             flex flex-col items-center justify-center text-center gap-y-2">
                {image && <img className="object-cover absolute inset-0 w-full h-full" src={image} />}
                <CameraIcon className="w-8 h-8 text-white" />
                Add or upload a photo
                <input ref={ref} onChange={onInputChange} type="file" accept="image/*" className="hidden"></input>
            </div>
        </div>
    )
}